export const ch_en_role = [
    {
        ch: '销售',
        en: 'SALES'
    }, {
        ch: '分析',
        en: 'ANALYST'
    }, {
        ch: '审核',
        en: 'AUDITOR'
    }, {
        ch: '技术支持',
        en: 'TECH'
    }]

const platform = [
    {
        ch: '多样性交付系统',
        en: 'AMPLICON'
    }, {
        ch: '转录组交付系统',
        en: 'TRANS'
    }, {
        ch: '其他类型项目交付系统',
        en: 'RAW_DATA'
    }, {
        ch: '宏基因组交付系统',
        en: 'METAG'
    },  {
        ch: '转录组交付系统',
        en: 'TRANS'
    }, {
        ch: '交付系统',
        en: '交付系统'
    }, {
        ch: '代谢组交付系统',
        en: 'METABO'
    },
]
export const modelChEn = {
    'NGS': '二代测序',
    'AMPLICON': '扩增子测序',
    'TGG': '三代测序',
    'METAPRO': '蛋白代谢组测序',
    'PURE': '纯分析',
    'PCR': '荧光定量/菌鉴',
    '二代测序': 'NGS',
    '扩增子测序': 'AMPLICON',
    '三代测序': 'TGG',
    '蛋白代谢组测序': 'METAPRO',
    '纯分析': 'PURE',
    '荧光定量/菌鉴': 'PCR',
}
const approvalStatus = [
    {
        ch: '待审批',
        en: 'PENDING'
    }, {
        ch: '同意',
        en: 'PASSED'
    },  {
        ch: '拒绝',
        en: 'DECLINED'
    },  {
        ch: '已完成',
        en: 'SUCCESS'
    },  {
        ch: '待修正',
        en: 'FILLING'
    },  {
        ch: '已失败',
        en: 'FAILED'
    }, {
        ch: '已取消',
        en: 'CANCEL'
    }, {
        ch: '上传中',
        en: 'CONSENTED'
    },
]
const mailSendStatus = [
    {
        ch: '已创建',
        en: 'CREATED'
    }, {
        ch: '未发送',
        en: 'IN_QUEUE'
    },  {
        ch: '已取消发送',
        en: 'CANCELED'
    }, {
        ch: '发送成功',
        en: 'SUCCESS'
    },{
        ch: '发送失败',
        en: 'FAIL'
    },
]
const mailType = [
    {
        ch: '上传',
        en: 'UPLOAD'
    }, {
        ch: '原始数据释放',
        en: 'RELEASE'
    },  {
        ch: '催款',
        en: 'DUNNING'
    }, {
        ch: '超时',
        en: 'TIMEOUT'
    }, {
        ch: '报告驳回',
        en: 'REFUSE_REPORT'
    }, {
        ch: '报告审批超时',
        en: 'REPORT_APPROVAL_TIMEOUT'
    }, {
        ch: '分析结果释放',
        en: 'RES_RELEASE'
    },{
        ch: '菌鉴结果释放',
        en: 'QC_RELEASE'
    },
]
const rawDataStatus = [
    {
        ch: '   无  ',
        en: 'NO_DATA',
    },{
        ch: '无原始数据',
        en: 'NO_DATA',
    }, {
        ch: '  未释放 ',
        en: 'NOT_RELEASED'
    },  {
        ch: ' 链接释放 ',
            en: 'LINK_RELEASED'
    },  {
        ch: '已释放(网盘)',
            en: 'LINK_RELEASED'
    }, {
        ch: '已释放(硬盘)',
        en: 'HDD_RELEASED'
    },{
        ch: ' 硬盘释放 ',
        en: 'HDD_RELEASED'
    },
]
export const rawDataStatusColor = {
        'NO_DATA':'primary',
        'NOT_RELEASED':'info',
        'LINK_RELEASED':'success',
        'HDD_RELEASED':'success',
    }
export const approvalStatusColor = {
        'PENDING':'primary',
        'FILLING':'warning',
        'CONSENTED':'info',
        'FAILED':'danger',
        'SUCCESS':'success',
    }
export const bsContractChEn = {
    'APPLY': '待审核',
    'REJECTED': '已驳回',
    'SIGN_FLOW_INITIATED': '签署发起成功',
    'OPERATOR_READ': '甲方已读',
    'SIGNED': '签署完成',
    'RETRACTED': '已撤销',
    'EXPIRED': '已过期',
    'INITIATION_FAILED': '签署发起失败',
    'AUTO': '自流转',
    'NOT_APPLYING': '未申请',
    'VISA_REFUSAL': '拒签',
    '待审核': 'APPLY',
    '已驳回': 'REJECTED',
    '签署发起成功': 'SIGN_FLOW_INITIATED',
    '甲方已读': 'OPERATOR_READ',
    '签署完成': 'SIGNED',
    '已撤销': 'RETRACTED',
    '已过期': 'EXPIRED',
    '签署发起失败': 'INITIATION_FAILED',
    '自流转': 'AUTO',
    '未申请': 'NOT_APPLYING',
    '拒签': 'VISA_REFUSAL'
}
export const modelNameChange ={
    '其他类型项目交付系统':'项目交付系统',
    '项目交付系统':'其他类型项目交付系统',
    '裸测-原始数据交付系统':'裸测项目交付系统',
    '裸测项目交付系统':'裸测-原始数据交付系统',
}
export function getRoleChByEn(val) {
    return transCh(ch_en_role, val)
}

export function getRoleEnByCh(val) {
    return transEn(ch_en_role, val)
}

export function getPlatformChByEn(val) {
    return transCh(platform, val)
}

export function getPlatformEnByCh(val) {
    return transEn(platform, val)
}
export function getApprovalStatusChByEn(val) {
    return transCh(approvalStatus, val)
}
export function getApprovalStatusEnByCh(val) {
    return transEn(approvalStatus, val)
}
export function getMailSendStatusChByEn(val) {
    return transCh(mailSendStatus, val)
}
export function getMailSendStatusEnByCh(val) {
    return transEn(mailSendStatus, val)
}
export function getMailTypeChByEn(val) {
    return transCh(mailType, val)
}
export function getMailTypeEnByCh(val) {
    return transEn(mailType, val)
}
export function getRawDataStatusChByEn(val) {
    return transCh(rawDataStatus, val)
}
export function getRawDataStatusEnByCh(val) {
    return transEn(rawDataStatus, val)
}
function transEn(arr, val) {
    if (val) {
        const foundItem = arr.find(item => item.ch.trim() === val)
        if (foundItem) {
            return foundItem.en
        } else {
            return ''
        }
    } else {
        return ''
    }
}
function transCh(arr, val) {
    if (val) {
        const foundItem = arr.find(item => item.en === val);
        if (foundItem) {
            return foundItem.ch;
        } else {
            return ''
        }
    } else {
        return ''
    }

}
